<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="careRemind">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            老人对账表
        </div>
        <div style="padding: 20px;">
            <div>
                <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="Search">
                    <template slot="monthrange">
                         <el-date-picker
                            v-model="searchForm.day"
                            type="date"
                            @change='changeDay'
                            value-format="yyyy-MM-dd"
                            placeholder="请选择日期">
                        </el-date-picker>
                    </template>
                    <template slot="rightButton">
                         <el-button type="success" icon="el-icon-download" @click="download">导出</el-button>
                    </template>
                </Search>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table ref="table" v-loading="tableload" :data="tableData" :height="th" border style="width: 100%;" >

                        <el-table-column prop="dayString" label="日期" min-width="100"></el-table-column>
                        <el-table-column prop="elderly.name" label="老人姓名" min-width="100"></el-table-column>
                        <el-table-column prop="balance" label="余额"  min-width="100"></el-table-column>
                        <el-table-column prop="balanceBefore" label="变化前余额"  min-width="100"></el-table-column>
                        <el-table-column prop="balanceChange" label="变动余额"  min-width="100"></el-table-column>
                        <el-table-column prop="deposit" label="预交金"  min-width="80"></el-table-column>
                        <el-table-column prop="imprest" label="备用金"  min-width="80"></el-table-column>
                        <el-table-column prop="changeType" :formatter="getType" label="改变类型"  min-width="180"></el-table-column>
                        <el-table-column prop="remark" label="备注"  min-width="100"></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" label="创建日期"  min-width="180"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getHeadInsStaffCode,getToken} from "@/utils/auth";
    import Search from "@/components/Search";

    export default {
        name: "Role",
        data(){
            return{
                tableload:false,
                dialogFeeChange:false,
                dialogHandChange:false,
                selectInfo:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                roomCodeList:[],
                feeTable:[],
                handTable:[],
                currentPage:1,
                roomCode:'00000000-0000-0000-0000-000000000000',
                number:'',
                status:-1,
                th:0,searchData:[],
                searchForm:{
                    day: '',
                    name: '',
                    idCard: '',
                    institutionCode: '',
                },
                options:[],
                institutionFeeList:[],
                deductionItemList:[],
                typeValue:['充值','自动扣费','手动扣费','请假退费','退住退款','备用金转余额','预交金转余额','清零退款']
            }
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },
        components: {
            Search
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                let staffDTO=JSON.parse(getToken())
                
                this.searchData=[
                    {span:12,name:'机构',width:210,value:'institutionCode',clearable:true,type:'select',options:staffDTO.institutionDTO.listSonInstitutionRelDTO,props:{label:'sonInstitutionName',value:'sonInstitutionCode'}},
                    {span:12,name:'姓名',width:210,value:'name',type:'input'},
                    {span:12,name:'身份证号',width:210,value:'idCard',type:'input'},
                    {span:24,name:'日期',width:210,value:'monthrange',type:'slot'},
                ]
                var nowDate=new Date(new Date().getTime()-24*60*60*1000);
                this.searchForm.day=timefilters(nowDate).slice(0,10)
                this.tableload=true
            },
            changeDay(val){
                if(val==null){
                    this.searchForm.day=''
                }
            },
            download(){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var params = new URLSearchParams();
                params.append('timeStr', timeStr);
                params.append('sign', hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
                params.append('staffCode', getHeadInsStaffCode());
                params.append('day', this.searchForm.day);
                params.append('idCard', this.searchForm.idCard);
                params.append('name', this.searchForm.name);
                this.$axios.get(this.$institutionUrl + 'CensusElderlyBalanceRecordDay/ExportElBalanceRecord', {
                responseType: 'blob',
                params: params
                }).then(
                    (response) => {
                    loading.close();
                    // this.goodsClassDataShow = !this.goodsClassDataShow;
                    if (response.data.type === 'application/json') {
                        this.$message({type: 'info', message: '暂无数据'});
                    } else {
                        let fileName = '老人对账统计表.xlsx';
                        this.file(response, fileName);
                    }

                    }
                )
            },
            file(response, fileName) {
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableload=true
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getHeadInsStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CensusElderlyBalanceRecordDay/Page",
                    data: data
                }).then( (response)=> {
                    this.tableload = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        // this.$nextTick(()=>{
                        //     this.$refs.table.doLayout()
                        // })
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    _this.tableload = false;
                    console.log(error);
                });
            },
            getType(row){
                if(row.changeType!=10){
                    return this.typeValue[row.changeType-1]
                }
                if(row.changeType==10){
                    return '多项费用变更'
                }
                return '其他';
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            openFee(data){
                this.dialogFeeChange=true;
                this.feeTable=data.censusAutomatchElderlyConsumeRecordMonthFees
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            openHand(data){
                this.dialogHandChange=true;
                this.handTable=data.censusAutomatchElderlyConsumeRecordMonthItems
            }
        }
    }
</script>

<style lang="scss" scoped>
    // .BerthPage{
    //     .el-button{
    //         transform: translate(-1px,0);
    //     }
    // }
    .careRemind /deep/ .el-table__body tr.current-row>td {
        background: rgb(102, 177, 255);
        color:#fff;
    }
</style>
